export const productList = [
  {
    id:1,
    name:"Body Protective Gear",
    image:require("../assets/images/products/product2.png")
  },
  {
    id:2,
    name:"Police Riot Shield",
    image: require("../assets/images/products/product4.png")
  },
  {
    id:3,
    name:"Police Riot Safety Helmet",
    image:require("../assets/images/products/product1.png")
  },
  {
    id:4,
    name:"Polycarbonate Lathy",
    image:require("../assets/images/products/product3.png")
  },
  {
    id:5,
    name:"Stun Gun",
    image:require("../assets/images/products/product5.png")
  },
  {
    id:6,
    name:"Stab proof vest",
    image:require("../assets/images/products/product6.png")
  },
  {
    id:7,
    name:"Tactical vest",
    image:require("../assets/images/products/Tactical_vest.png")
  },
  {
    id:8,
    name:"Work Vest",
    image:require("../assets/images/products/Work_Vest.png")
  },
  {
    id:9,
    name:"High Visibility vest",
    image:require("../assets/images/products/High_Visibility_vest.png")
  },
  {
    id:10,
    name:"LED light Batons",
    image:require("../assets/images/products/LED_light_Batons.png")
  },
  {
    id:11,
    name:"Movable Metal barricades",
    image:require("../assets/images/products/Movable_Metal_barricades.png")
  },
  {
    id:12,
    name:"Life jackets",
    image:require("../assets/images/products/Life_jackets.png")
  },
  {
    id:13,
    name:"Life Buoys",
    image:require("../assets/images/products/Life_Buoys.png")
  },
  {
    id:14,
    name:"Inflatable Tents",
    image:require("../assets/images/products/Inflatable_Tents.png")
  },
  {
    id:15,
    name:"Fishing Wader suit",
    image:require("../assets/images/products/Fishing_Wader_suit.png")
  },
  {
    id:16,
    name:"Full Wet Suit",
    image:require("../assets/images/products/Full_Wet_Suit.png")
  },
  {
    id:17,
    name:"LED Torches",
    image:require("../assets/images/products/LED_Torches.png")
  },
  {
    id:18,
    name:"Traffic Cones",
    image:require("../assets/images/products/Traffic_Cones.png")
  },
  {
    id:19,
    name:"HDPE barricades",
    image:require("../assets/images/products/HDPE_barricades.png")
  },
  {
    id:20,
    name:"Backpacks",
    image:require("../assets/images/products/Backpacks.png")
  },
  {
    id:21,
    name:"Under vehicle Inspection System",
    image:require("../assets/images/products/Under_vehicle_Inspection_System.png")
  },
  {
    id:22,
    name:"Rafting Helmet",
    image:require("../assets/images/products/Rafting_Helmet.png")
  },
  {
    id:23,
    name:"Throw Bag",
    image:require("../assets/images/products/Throw_Bag.png")
  },
  {
    id:24,
    name:"Dive Boot",
    image:require("../assets/images/products/Dive_Boot.png")
  },
  {
    id:25,
    name:"Inflatable Boat",
    image:require("../assets/images/products/Inflatable_Boat.png")
  },
  {
    id:26,
    name:"High Visibility Rainwear",
    image:require("../assets/images/products/High_Visibility_Rainwear.png")
  },
  {
    id:27,
    name:"Safety Gum Boots",
    image:require("../assets/images/products/Safety_Gum_Boots.png")
  },
  {
    id:28,
    name:"Safety Shoes/Boots",
    image:require("../assets/images/products/Safety_Shoes_Boots.png")
  },
  {
    id:29,
    name:"Geezbo tents",
    image:require("../assets/images/products/Geezbo_tents.png")
  }
]